var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordCloudChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.85,
    height: 30.75,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37310",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8521",
    stroke: "#1c9f00",
    strokeWidth: 5,
    d: "M14.15 16.25h7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8553",
    stroke: "#deaa0c",
    strokeWidth: 5,
    d: "M28.15 16.25h3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8522",
    stroke: "#dc1e1e",
    strokeWidth: 3,
    d: "M7.15 22.25h16"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8526",
    stroke: "#dc1e1e",
    strokeWidth: 3,
    d: "M21.15 10.25h10"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8530",
    stroke: "#deaa0c",
    strokeWidth: 2,
    d: "M15.779 5.25h5.524"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8540",
    stroke: "#deaa0c",
    d: "M1.176 7.25H6.7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8544",
    stroke: "#dc1e1e",
    d: "M15.374 30.25h5.524"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8535",
    stroke: "#1c9f00",
    strokeWidth: 2,
    d: "M15.779 27.25h5.524"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8523",
    stroke: "#1c9f00",
    strokeWidth: 3,
    d: "M29.15 22.25h6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8525",
    stroke: "#dc1e1e",
    strokeWidth: 3,
    d: "M36.15 16.25h6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8527",
    stroke: "#1c9f00",
    strokeWidth: 3,
    d: "M10.15 10.25h6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8531",
    stroke: "#dc1e1e",
    strokeWidth: 2,
    d: "M9.15 5.25h3.314"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8536",
    stroke: "#deaa0c",
    strokeWidth: 2,
    d: "M9.15 27.25h3.314"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8528",
    stroke: "#deaa0c",
    strokeWidth: 3,
    d: "M36.15 10.25h2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8537",
    stroke: "#dc1e1e",
    strokeWidth: 3,
    d: "M3.15 10.25h2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8529",
    stroke: "#dc1e1e",
    strokeWidth: 2,
    d: "M24.064 5.25h1.105"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8539",
    stroke: "#deaa0c",
    d: "M24.064 2.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8542",
    stroke: "#1c9f00",
    d: "M41.25 12.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8546",
    stroke: "#1c9f00",
    d: "M38.15 20.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8541",
    stroke: "#dc1e1e",
    d: "M17.5 2.25h4.65"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8550",
    stroke: "#1c9f00",
    strokeWidth: 0.5,
    d: "M12.464 2.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8551",
    stroke: "#dc1e1e",
    strokeWidth: 0.5,
    d: "M21.303.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8552",
    stroke: "#deaa0c",
    strokeWidth: 0.5,
    d: "M23.619 30.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8549",
    stroke: "#deaa0c",
    d: "M10.15 2.25h1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8543",
    stroke: "#deaa0c",
    d: "M34.6 25.25h1.55"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8545",
    stroke: "#deaa0c",
    d: "M3.6 25.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8547",
    stroke: "#deaa0c",
    d: "M1.6 19.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8548",
    stroke: "#1c9f00",
    d: "M.5 22.25h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8534",
    stroke: "#dc1e1e",
    strokeWidth: 2,
    d: "M24.064 27.25h1.105"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8532",
    stroke: "#1c9f00",
    strokeWidth: 2,
    d: "M28.483 5.25h3.667"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8533",
    stroke: "#deaa0c",
    strokeWidth: 2,
    d: "M28.483 27.25h3.667"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8524",
    stroke: "#deaa0c",
    strokeWidth: 3,
    d: "M2.15 16.25h6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordCloudChart);
export default __webpack_public_path__ + "static/media/wordCloudChart.b771f44c05ddff8680ef7ac4bcf16f8d.svg";
export { ForwardRef as ReactComponent };